<template>
  <div class="p-8 w-full h-full"
       v-loading="loading"
       element-loading-text="Loading..."
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(255, 255, 255, 0.9)" >
    <el-collapse class="min-h-full" accordion>
      <el-collapse-item title="Basic Information" name="Basic">
        <BasicDetailsForm :edit="true" :action="'edit'" @updateBasic="updateBasic" @reset="reset" :loading="basicLoading" />
      </el-collapse-item>
      <el-collapse-item class="min-h-full" title="Catalog" name="catalog">
        <CatalogForm  :edit="true" :action="'edit'" @updateCatalog="updateCatalog" :loading="catalogLoading" />
      </el-collapse-item>
      <el-collapse-item title="Attribute" name="attributes">
        <AttributeForm  :edit="true" :action="'edit'" @updateAttribute="updateAttribute" :loading="attributeLoading" />
      </el-collapse-item>
      <el-collapse-item title="Configuration" name="configs">
        <Configuration  :edit="true" :action="'edit'" @updateConfiguration="updateConfiguration" :loading="configLoading" />
      </el-collapse-item>
      <el-collapse-item title="Images" name="images">
        <DeleteImage />
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import BasicDetailsForm from './_includes/Forms/BasicDetailsForm.vue';
import CatalogForm from './_includes/Forms/CatalogForm.vue';
import AttributeForm from './_includes/Forms/AttributeForm.vue';
import Configuration from './_includes/Forms/Configuration.vue';
import DeleteImage from './_includes/Forms/DeleteImage.vue';

export default {
  name: 'EditProduct',
  components: {
    BasicDetailsForm,
    CatalogForm,
    AttributeForm,
    Configuration,
    DeleteImage,
  },
  data() {
    return {
      loading: false,
      basicLoading: false,
      catalogLoading: false,
      attributeLoading: false,
      configLoading: false,
    };
  },
  methods: {
    reset(key) {
      this.$store.commit('InventoryModule/Products/resetProductMultipleData', { action: 'edit', parent: key });
    },

    async updateBasic() {
      this.basicLoading = true;
      try {
        await this.$store.dispatch('InventoryModule/Products/updateProductBasic', { productId: this.$route.params.id });
        this.$notify.success({
          title: 'Success',
          message: 'Basic Information Successfully Updated',
        });
      } catch (e) {
        this.$notify.error({
          title: 'Error',
          message: 'Something went wrong please try again.',
        });
      }
      this.basicLoading = false;
    },

    async updateCatalog() {
      this.catalogLoading = true;
      try {
        await this.$store.dispatch('InventoryModule/Products/updateOrCreateItemCatalogItemOutlets', { productId: this.$route.query.id, productSlug: this.$route.params.id });
        this.$notify.success({
          title: 'Success',
          message: 'Catalog and Outlets Successfully Updated',
        });
      } catch (e) {
        this.$notify.error({
          title: 'Error',
          message: 'Something went wrong please try again.',
        });
      }
      this.catalogLoading = false;
    },

    async updateAttribute() {
      this.attributeLoading = true;
      try {
        await this.$store.dispatch('InventoryModule/Products/updateOrCreateItemAttribute', { productId: this.$route.query.id, productSlug: this.$route.params.id });
        this.$notify.success({
          title: 'Success',
          message: 'Attribute Successfully Updated',
        });
      } catch (e) {
        this.$notify.error({
          title: 'Error',
          message: 'Something went wrong please try again.',
        });
      }
      this.attributeLoading = false;
    },

    async updateConfiguration() {
      this.configLoading = true;
      try {
        await this.$store.dispatch('InventoryModule/Products/updateOrCreateItemConfigItemAvailableDay', { productId: this.$route.query.id, productSlug: this.$route.params.id });
        this.$notify.success({
          title: 'Success',
          message: 'Configurations Successfully Updated',
        });
      } catch (e) {
        this.$notify.error({
          title: 'Error',
          message: 'Something went wrong please try again.',
        });
      }
      this.configLoading = false;
    },
  },
  async mounted() {
    this.loading = true;
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
    // Get the current
    try {
      await this.$store.dispatch('InventoryModule/Products/fetchProduct', { productId: this.$route.params.id });
      this.dataLoading = true;
    } catch (e) {
      //
    }

    this.loading = false;
  },
};
</script>

<style scoped>
  .el-collapse-item__wrap {
    overflow: scroll !important;
  }
</style>
